<template>
    <div class="flex flex-wrap items-end mb-6">
      <div class="py-2 w-full">
        <text-input
          label="Postcode Search"
          v-model="searchParams.postcode"
          :error="searchErrorBag.get('postcode')" />
        <select-input
          label="Address"
          :options="suggestions"
          :placeholder="suggestions.length === 0 ? '[No Results]' : '[Please Select]'"
          option-key="formatted"
          option-value="data"
          v-model="selectedSuggestion" />
      </div>
      <div v-if="addressValue" class="w-full p-3 border">
        <div>Address Preview:</div>
        {{addressValue}}
      </div>
    </div>
  </template>
<script>
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: {
    label: String,
    placeholder: String,
    value: String,
    errorBag: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addressValue: this.value,
      searchParams: {
        postcode: null
      },
      suggestions: [],
      selectedSuggestion: null,
      searchErrorBag: new ErrorBag()
    }
  },
  computed: {
    ...mapState(['enums']),
    error () {
      const errors = [
        this.errorBag.get(this.addressValue)
      ]
      for (let i = 0; i < errors.length; i++) {
        if (errors[i]) {
          return errors[i]
        }
      }
      return null
    }
  },
  methods: {
    search: debounce(function () {
      if (!RegExp('^[A-PR-UWYZ][A-HJ-Y]?[0-9][0-9A-HJKMNPR-Y]? ?[0-9][ABD-HJLNP-UW-Z]{2}$', 'gi').test(this.searchParams.postcode)) {
        return
      }
      api.get('address-lookup', {
        params: this.searchParams
      }).then((response) => {
        this.suggestions = response.data
      }, (errors) => {
        this.searchErrorBag.store(errors.response.data)
      })
    }, 500)
  },
  watch: {
    searchParams: {
      handler () {
        this.search()
      },
      deep: true
    },
    selectedSuggestion: {
      handler () {
        let address = [
          this.selectedSuggestion.address_name_number,
          this.selectedSuggestion.address_line2,
          this.selectedSuggestion.address_line3,
          this.selectedSuggestion.address_town,
          this.selectedSuggestion.address_line4,
          this.selectedSuggestion.address_postcode
        ].filter(Boolean)
        if (address.length) {
          address.push(this.selectedSuggestion.address_country)
        }
        this.addressValue = address.join(', ')
        this.$emit('input', this.addressValue)
        this.$emit('selected', this.selectedSuggestion)
      },
      deep: true
    }
  }
}
</script>
